import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarUserComponent } from './toolbar-user.component';
import { ToolbarUserDropdownComponent } from './toolbar-user-dropdown/toolbar-user-dropdown.component';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { RelativeDateTimeModule } from '../../../pipes/relative-date-time/relative-date-time.module';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SidebarModule } from 'src/@vex/components/sidebar/sidebar.module';
import { ConfigPanelModule } from 'src/@vex/components/config-panel/config-panel.module';
import { MbscModule } from '@mobiscroll/angular';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [ToolbarUserComponent, ToolbarUserDropdownComponent],
  imports: [
    CommonModule,
    MbscModule,
    MatIconModule,
    MatRippleModule,
    MatMenuModule,
    MatButtonModule,
    RelativeDateTimeModule,
    RouterModule,
    MatTooltipModule,
    SidebarModule,
    ConfigPanelModule,
    MatNativeDateModule,
  ],
  exports: [ToolbarUserComponent]
})
export class ToolbarUserModule {
}



